import { AxiosPromise } from "axios";
import { BaseApi, cookieAuthorizedApi } from "ecom-teams-apps-core";
import { AdminAuthDto } from "./api/AdminAuthDto";

export interface AdminAuthorizationService {
    getOnetimeAuthToken(): AxiosPromise<AdminAuthDto>;
}

export class DefaultAdminAuthorizationService implements AdminAuthorizationService {
    private getAdminAuthorizationServiceUrl: string = `/secured/user/onetime-auth-token?appName=APP_PINPOINT_ADMINISTRATION`;

    constructor(private cookieAuthorizedApi: BaseApi) {}

    getOnetimeAuthToken(): AxiosPromise<AdminAuthDto> {
        return this.cookieAuthorizedApi.get<AdminAuthDto>(this.getAdminAuthorizationServiceUrl);
    }
}

export class AdminAuthorizationServiceWithResponse implements AdminAuthorizationService {
    _response: any = {
        data: this.response,
    };

    constructor(private response: any) {}

    getOnetimeAuthToken() {
        return Promise.resolve(this._response);
    }
}

export class AdminAuthorizationServiceWithError implements AdminAuthorizationService {
    constructor(private error: any) {}

    getOnetimeAuthToken() {
        return Promise.reject(this.error);
    }
}

export default new DefaultAdminAuthorizationService(cookieAuthorizedApi);